import React from "react";
import { Box } from "@mui/material";
import Tune from "@mui/icons-material/Tune";

import SleekMultiSelect from "../SleekMultiSelect";
import SleekSingleSelect from "../SleekSingleSelect";
import RTMFilterPanel from "./RTMFilterPanel";

const RTMFilterBar = ({
  mappings,
  options,
  filters,

  templateOpen,
  setTemplateOpen,
  templateRef,

  projectOpen,
  setProjectOpen,
  projectRef,

  issueTypeOpen,
  setIssueTypeOpen,
  issueTypeRef,

  fixVersionOpen,
  setFixVersionOpen,
  fixVersionRef,

  filtersOpen,
  setFiltersOpen,
  filtersRef,

  handleChange,
  setFilters,
}) => {
  return (
    <Box className="rtm-filter-bar">
      {/* Template */}
      <SleekSingleSelect
        placeholder="Select Template"
        options={options.templates}
        selectedValue={mappings.template}
        onChange={(id) => handleChange("template", id)}
        isOpen={templateOpen}
        setOpen={setTemplateOpen}
        innerRef={templateRef}
        displayFormatter={(opt) => opt.label}
      />

      {/* Project */}
      {mappings.template && (
        <SleekSingleSelect
          placeholder="Select Project"
          options={options.projects}
          selectedValue={mappings.project?.id}
          onChange={(id, obj) => handleChange("project", obj)}
          isOpen={projectOpen}
          setOpen={setProjectOpen}
          innerRef={projectRef}
          displayFormatter={(opt) => `${opt.key} - ${opt.name}`}
        />
      )}

      {/* Issue Types + Versions */}
      {mappings.template && mappings.project && (
        <>
          {/* Issue Types */}
          {mappings.template !== "executionRtm" && (
            <SleekMultiSelect
              placeholder="Select Issue Types"
              options={options.issueTypes}
              selectedValues={mappings.issueTypes.map((i) => i.id)}
              selectedNames={mappings.issueTypes.map((i) => i.name)}
              onSelectionChange={(ids) => {
                const selectedObjs = options.issueTypes.filter((o) =>
                  ids.includes(o.id)
                );
                handleChange("issueTypes", selectedObjs);
              }}
              isOpen={issueTypeOpen}
              setOpen={(val) => {
                setIssueTypeOpen(val);
                if (val) setFixVersionOpen(false);
              }}
              innerRef={issueTypeRef}
            />
          )}

          {/* Versions */}
          {mappings.template !== "executionRtm" ? (
            <SleekMultiSelect
              placeholder="Select Versions"
              options={options.fixVersions}
              selectedValues={mappings.fixVersions.map((v) => v.id)}
              selectedNames={mappings.fixVersions.map((v) => v.name)}
              onSelectionChange={(ids) => {
                const selectedObjs = options.fixVersions.filter((o) =>
                  ids.includes(o.id)
                );
                handleChange("fixVersions", selectedObjs);
              }}
              isOpen={fixVersionOpen}
              setOpen={(val) => {
                setFixVersionOpen(val);
                if (val) setIssueTypeOpen(false);
              }}
              innerRef={fixVersionRef}
            />
          ) : (
            <SleekSingleSelect
              placeholder="Select Version"
              options={options.fixVersions}
              selectedValue={mappings.fixVersions[0]?.id || ""}
              onChange={(id, obj) =>
                handleChange("fixVersions", obj ? [obj] : [])
              }
              isOpen={fixVersionOpen}
              setOpen={(val) => {
                setFixVersionOpen(val);
                if (val) setIssueTypeOpen(false);
              }}
              innerRef={fixVersionRef}
              displayFormatter={(opt) => opt.name}
            />
          )}

          {/* Filters */}
          {mappings.template !== "executionRtm" && (
            <Box className="rtm-filter-wrapper" ref={filtersRef}>
              <Box
                onClick={() => setFiltersOpen((prev) => !prev)}
                sx={{ position: "relative", display: "inline-flex" }}
              >
                <Tune
                  sx={{
                    fontSize: 20,
                    backgroundColor: "#f5f7f8",
                    cursor: "pointer",
                    color: "#3a85ef",
                    borderRadius: "4px",
                  }}
                />

                {(filters.startDate ||
                  filters.endDate ||
                  filters.priority.length > 0 ||
                  filters.labels.length > 0) && (
                  <span className="jb-filter-badge">
                    {(filters.startDate ? 1 : 0) +
                      (filters.endDate ? 1 : 0) +
                      filters.priority.length +
                      filters.labels.length}
                  </span>
                )}
              </Box>

              {filtersOpen && (
                <RTMFilterPanel
                  filters={filters}
                  setFilters={setFilters}
                  options={options}
                />
              )}
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default RTMFilterBar;